import React from 'react';
import { StatusPill } from './StatusPill';
import { deriveRunDisplayStatus, formatRunStatus } from './format';
import { RUN_PULSING_STATUSES, RUN_STATUS_TOKENS, tokenFor } from './statusTokens';

// A run's status as a pill. `stuck: true` overrides the wire status with a negative "Stuck"; the
// in-flight stages pulse.
export const RunStatusBadge = ({ run }) => {
  const status = deriveRunDisplayStatus(run);
  if (!status) return null;
  return (
    <StatusPill
      token={tokenFor(RUN_STATUS_TOKENS, status)}
      label={formatRunStatus(status)}
      pulse={RUN_PULSING_STATUSES.includes(status)}
    />
  );
};
